module.exports = __webpack_public_path__ + "static/edit-banner-newsletter-popup-1dce6f44e1a9c3a76743d75a68150245.png";